import { Col, Tabs, Row, Select, Tag, Collapse, Divider } from 'antd';
import { AddIcon, DollarSign, DownloadIcon, Edit2 } from 'assets/svg';
import { MainLayout } from 'components';
import type { CollapseProps } from 'antd';
import type { TabsProps } from 'antd';
import Button from 'components/Button';
import React, { useEffect, useState } from 'react';
import pageTitleStore from 'store/pageTitleStore';
import { BranchesOutlined } from '@ant-design/icons';
import { Content } from 'antd/es/layout/layout';
import DraftTable from '../../../components/Modules/Allocated/Allocatedetails/DraftTable';
import StoreTable from '../../../components/Modules/Allocated/Allocatedetails/StoreTable';
import { useHistory, useLocation } from 'react-router-dom';
import AllocateApi from 'apis/AllocateApi';
import { useMutation } from 'react-query';
import handleError401 from 'utils/handleError401';
import { STATUS } from 'constants/reponseStatus';
import { useUser } from 'contexts/User';
import formatCurrencyVND from 'utils/formatCurrencyVND';
import CapitalApi from 'apis/CapitalApi';

export default function Allocatedetails() {
  // const allocateData = useLocation().state as any;
  const [allocateData, setAllocateData] = useState<any>(useLocation().state);
  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  const history = useHistory();
  const { user } = useUser();
  const { Option } = Select;
  const [totalCapitalMax, setTotalCapitalMax] = useState<any>(0);
  const [allocatedYear, setAllocatedYear] = useState<number>(
    new Date().getFullYear()
  );
  const [allocationDetailData, setAllocateDetailData] = useState<any>();
  const [yearOption, setYearOption] = useState<any>();
  const [isCapitalYearLoaded, setIsCapitalYearLoaded] = useState(false);
  const branch_code =
    allocateData?.branch_code ?? user?.branch_code ?? user?.plantCode;

  const { mutate: getYearOption } = useMutation(CapitalApi.getYearOptionList, {
    onSuccess: (response: any) => {
      if (response.status === STATUS.SUCCESS) {
        setYearOption(response?.data);
      }
    },
    onError: (error: any) => {
      if (error.response.data.status === 401) {
        handleError401();
      }
    },
  });
  const { mutate: getData } = useMutation(
    ['get'],
    () => AllocateApi.getDetailByBranchCode(branch_code, Number(allocatedYear)),
    {
      onSuccess: (response: any) => {
        if (response.status === STATUS.SUCCESS) {
          setAllocateDetailData(response?.data);
          getYearOption(response?.data?.branch_id);
        }
      },
      onError: (error: any) => {
        if (error.response.data.status === 401) {
          handleError401();
        }
      },
    }
  );

  useEffect(() => {
    if (!branch_code) {
      setIsCapitalYearLoaded(true);
      return;
    }

    const fetchMaxCapitalYear = async () => {
      try {
        const response = await AllocateApi.getMaxCapitalYear(branch_code);
        const maxCapitalYear = response?.data?.max_capital_year;

        if (maxCapitalYear) {
          const parsedYear = Number(maxCapitalYear);
          if (!Number.isNaN(parsedYear)) {
            setAllocatedYear(parsedYear);
          }
        }
      } catch (error: any) {
        if (error?.response?.status === 401) {
          handleError401();
        }
      } finally {
        setIsCapitalYearLoaded(true);
      }
    };

    fetchMaxCapitalYear();
  }, [branch_code]);

  useEffect(() => {
    if (!isCapitalYearLoaded) {
      return;
    }
    setTitle(`Phân bổ vốn tồn  ${Number(allocatedYear)}`);
    setBreadcrumb([
      {
        title: (
          <p>
            <a href="/branchs-capital">Thông tin đơn vị</a>
          </p>
        ),
      },
      {
        title: (
          <a href="/branchs-capital-detail">
            Phân bổ vốn tồn {Number(allocatedYear)}
          </a>
        ),
      },
    ]);
    if (branch_code != null && branch_code != undefined) {
      getData();
    }
  }, [allocatedYear, branch_code, isCapitalYearLoaded]);

  function handleOnchangeYear(value: any) {
    setAllocatedYear(Number(value));
  }

  const yearOptionList = yearOption?.filter(
    (option: any) => option.type === 'year'
  )[0]?.list;

  const items: CollapseProps['items'] = [
    {
      key: '1',
      label: (
        <Row align="middle" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col span={2} className="mx-2">
            <Tag color="#00538F" className="custom-tag">
              <span className="text-base font-bold mt-4">Mới tạo</span>
            </Tag>
          </Col>
          <Col span={20} className="text-left text-xl font-bold">
            Phân bổ vốn tồn {Number(allocatedYear)}
          </Col>
        </Row>
      ),
      children: (
        <div className="px-4">
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="space-between"
          >
            <Col span={8}>
              <Row className="my-1" align={'middle'}>
                <Col span={2}>
                  <DollarSign />
                </Col>
                <Col span={22}>Tổng vốn chi nhánh</Col>
              </Row>
              <Row>
                <Col span={22} offset={2}>
                  {formatCurrencyVND(allocationDetailData?.total_capital_value)}
                </Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row className="my-1" align={'middle'}>
                <Col span={2}>
                  <DollarSign />
                </Col>
                <Col span={22}>Tổng vốn phân bố cửa hàng</Col>
              </Row>
              <Row>
                <Col className="text-primary-50 font-bold" span={22} offset={2}>
                  {formatCurrencyVND(allocationDetailData?.total_capital_max)}
                </Col>
              </Row>
            </Col>
            <Col span={8}>
              {/* <Row className="my-1" align={'middle'}>
                <Col span={2}>
                  <DollarSign />
                </Col>
                <Col span={22}>Tổng vốn đã phê duyệt</Col>
              </Row>
              <Row>
                <Col span={22} offset={2}>
                  {formatCurrencyVND(0)}
                </Col>
              </Row> */}
            </Col>
          </Row>

          <Divider />

          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="space-between"
            className="mb-6"
          >
            <Col span={8}>
              <Row className="my-1" align={'middle'}>
                <Col span={2}>
                  <DollarSign />
                </Col>
                <Col span={22}>Khu vực</Col>
              </Row>
              <Row>
                <Col span={22} offset={2}>
                  {allocationDetailData?.area_name}
                </Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row className="my-1" align={'middle'}>
                <Col span={2}>
                  <DollarSign />
                </Col>
                <Col span={22}>Mã chi nhánh</Col>
              </Row>
              <Row>
                <Col span={22} offset={2}>
                  {allocationDetailData?.branch_code}
                </Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row className="my-1" align={'middle'}>
                <Col span={2}>
                  <BranchesOutlined />
                </Col>
                <Col span={22}>Chi nhánh</Col>
              </Row>
              <Row>
                <Col span={22} offset={2}>
                  {allocationDetailData?.branch_name}
                </Col>
              </Row>
            </Col>
          </Row>

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="start">
            <Col span={8}>
              <Row className="my-1" align={'middle'}>
                <Col span={2}>
                  <DollarSign />
                </Col>
                <Col span={22}>Người phân bố</Col>
              </Row>
              <Row>
                <Col span={22} offset={2}>
                  {allocationDetailData?.created_by}
                </Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row className="my-1" align={'middle'}>
                <Col span={2}>
                  <DollarSign />
                </Col>
                <Col span={22}>Email</Col>
              </Row>
              <Row>
                <Col span={22} offset={2}>
                  {allocationDetailData?.email}
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      ),
    },
  ];
  const tableItems: TabsProps['items'] = [
    {
      key: '1',
      label: 'Phân bố vốn cửa hàng',
      children: (
        <StoreTable
          capital_branch_id={allocationDetailData?.capital_branch_id}
          totalCapitalMax={totalCapitalMax}
        />
      ),
    },
    // {
    //   key: '2',
    //   label: 'Bản nháp',
    //   children: <DraftTable />,
    // },
  ];

  return (
    <MainLayout>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="space-between">
        <Col span={8}>
          <Select
            value={allocatedYear}
            size="middle"
            className="w-28"
            onChange={(value) => handleOnchangeYear(value)}
          >
            {yearOptionList &&
              yearOptionList.map((item: any) => (
                <Option key={item.capital_year} value={item.capital_year}>
                  {item.capital_year}
                </Option>
              ))}
          </Select>
        </Col>
        <Col span={16}>
          <Row justify="end" className="gap-4">
            <Col>
              <Button
                onClick={() =>
                  history.push(`/branchs-capital-create/declare`, {
                    allocationDetailData,
                    btn: 'Create',
                  })
                }
              >
                {' '}
                <AddIcon /> Tạo mới
              </Button>
            </Col>
            {/* <Col>
              {' '}
              <Button
                disabled={allocationDetailData == undefined ? true : false}
                onClick={() =>
                  history.push(`/branchs-capital-create/declare`, {
                    allocationDetailData,
                    btn: 'Edit',
                  })
                }
              >
                {' '}
                <Edit2 /> Chỉnh sửa
              </Button>
            </Col> */}
            {/* <Col>
              <Button
                bgColor="bg-white"
                border="border-primary-50"
                color="text-primary-50"
              >
                <DownloadIcon />
                Tải file excel
              </Button>
            </Col> */}
          </Row>
        </Col>
      </Row>

      <div className="mt-7 bg-white rounded-lg">
        <Collapse
          defaultActiveKey={['1']}
          expandIconPosition="end"
          items={items}
          ghost
        />
      </div>

      <Content className="main-content mt-7">
        <Tabs defaultActiveKey="1" items={tableItems} />
      </Content>
    </MainLayout>
  );
}
